/**
 * Di che versione è questa copia dell'app.
 *
 * ## Il numero è uno, e sta in `player-app/package.json`
 *
 * Da lì lo legge **Vite**, che lo cuce dentro il pacchetto come `__PLAYER_VERSION__`, e lo legge
 * **Gradle**, che ne fa `versionName` e `versionCode` dell'APK. Ed è lo stesso numero con cui il
 * rilascio si registra nel license-manager.
 *
 * Tre posti, un numero, e non è pignoleria: se il pacchetto web avesse una versione sua, l'app
 * confronterebbe *quella* con le versioni degli **artefatti** pubblicate dal registro — due scale
 * diverse — e proporrebbe aggiornamenti a caso. Il confronto ha senso solo fra la versione
 * dell'artefatto installato e quelle degli artefatti disponibili.
 *
 * ## `null` significa «non lo so», e non è un ripiego
 *
 * Succede dove l'app non è impacchettata: il server di sviluppo e le prove. Lì la costante non è
 * stata sostituita da nessuno, e non esiste nessun artefatto installato da aggiornare.
 *
 * Non si ripiega su `'0.0.0'`: con uno zero di comodo **ogni** versione del registro sembrerebbe
 * nuova, e l'app proporrebbe un aggiornamento a chi sta già all'ultima. Un numero inventato qui
 * diventa una domanda sbagliata al registro.
 *
 * E perché `null` non diventi una funzione che sparisce in silenzio — un pacchetto distribuito senza
 * la propria versione non avviserebbe mai di niente, senza che nessuno se ne accorga —
 * `scripts/sync-android-assets.mjs` **rifiuta** di impacchettare un `dist/` in cui la versione non è
 * stata sostituita.
 */

declare const __PLAYER_VERSION__: string | undefined;

/** La versione dell'artefatto installato, o `null` se questa copia non è impacchettata. */
export function appVersion(): string | null {
  // `typeof` e non un accesso diretto: dove Vite non ha definito la costante, leggerla solleva
  // `ReferenceError` — e un errore in questo punto fermerebbe l'avvio dell'app per sapere un numero
  // che serve solo a offrire un aggiornamento.
  if (typeof __PLAYER_VERSION__ !== 'string') return null;
  return __PLAYER_VERSION__ === '' ? null : __PLAYER_VERSION__;
}
